import { HeaderConstants } from './header.constants';

/** Header bell badge text: null when zero, "99+" above the cap. */
export function formatUnreadBadge(count, max = HeaderConstants.UNREAD_BADGE_MAX) {
    const n = Number(count) || 0;
    if (n <= 0) return null;
    return n > max ? `${max}+` : String(n);
}
